export default __webpack_public_path__ + "static/media/Busca3.1d729991.jpeg";